import * as React from "react";
import { useTranslation } from "react-i18next";
import TextEditor from "../../TextEditor";

interface IOwnProps {
  isHighlightErrorMode?: boolean;
  onChange?: (newValue: string) => void;
  value: string;
  readOnly: boolean;
  placeholder?: string;
  invalid?: boolean;
  disabled?: boolean;
}

export const FreeTextQuestion = ({
  onChange,
  readOnly,
  value,
  placeholder,
  invalid = false,
  disabled = false
}: IOwnProps) => {
  const { t } = useTranslation();
  const handleChange = React.useCallback(
    (newValue: string) => {
      if (onChange) {
        return onChange(newValue);
      }
    },
    [onChange]
  );

  return (
    <TextEditor
      disabled={disabled}
      dataTestId="textEditor"
      readOnly={readOnly}
      invalid={invalid}
      placeholder={placeholder || t(`feedback.companyValue.placeholder`)}
      defaultValue={value}
      onChange={handleChange}
      enableGrow
      enableHeadings
    />
  );
};
